import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import { colors, gaps } from "theme/defaultStyle";

const TextStyles = styled("span")({
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  gap: gaps.small1,
});

interface AdvancedSearchButtonProps {
  open: boolean;
  onClick: () => void;
  disabled?: boolean;
}

const AdvancedSearchButton = ({ open, onClick, disabled = false }: AdvancedSearchButtonProps) => (
  <Button
    disabled={disabled}
    style={{
      backgroundColor: disabled ? undefined : open ? colors.blue13 : colors.white,
      opacity: disabled ? undefined : 1,
      textTransform: "none",
    }}
    onClick={onClick}
  >
    <TextStyles>
      Advanced
      <SearchIcon />
    </TextStyles>
  </Button>
);

export default AdvancedSearchButton;
